import { useCallback, useEffect, useState } from "react";

/**
 * Track whether a loading state has exceeded a timeout threshold.
 * Useful to swap endless spinners for actionable retry UI.
 */
const useLoadingTimeout = (isLoading, timeoutMs = 12000) => {
  const [hasTimedOut, setHasTimedOut] = useState(false);

  const resetTimeout = useCallback(() => {
    setHasTimedOut(false);
  }, []);

  useEffect(() => {
    if (!isLoading) {
      setHasTimedOut(false);
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setHasTimedOut(true);
    }, timeoutMs);

    return () => window.clearTimeout(timeoutId);
  }, [isLoading, timeoutMs]);

  return { hasTimedOut, resetTimeout };
};

export default useLoadingTimeout;
